module.exports = __webpack_public_path__ + "static/media/ux.4658893d.svg";